import _ from 'lodash';
import psHttp from '@patsnap/common-ps-http';
import { coreBasicApiUrlPrefix } from '../../config/constants';
import { requestConfigWrapper, PersistentCacheConfig, PersistentCacheStrategy } from '@patsnap/common-ps-http/dist/PersistentCache';

// 缓存机制的配置
const persistCacheConf = new PersistentCacheConfig({
    strategy: PersistentCacheStrategy.CACHE_FIRST_WITH_SILENT_UPDATE,
    detectAllowCachingHook(resp) {
        if (!resp.ok) return false;
        return resp.json()
            .then(body => (body.status && !_.isEmpty(body.data)))
            .catch(() => false);
    },
    async afterSilentCacheUpdateCompareHook(newResponse, historicalResponse) {
        const newResult = _.get(await newResponse.json(), 'data', {});
        const historicalResult = _.get(await historicalResponse.json(), 'data', {});
        const isNoraven = (window.location.search || '').indexOf('noraven=1') !== -1;
        if (!_.isEmpty(newResult) && !_.isEmpty(historicalResult) && !_.isEqual(newResult, historicalResult) && !isNoraven) {
            window.location.reload();
        }
    },
    VaryHeadersArray: ['authorization', 'x-api-version', 'x-site-lang']
});

// 添加缓存机制，该接口不会频繁变动，不需要每次都重新请求
// legalStatus,simpleLegalStatus,legalEvents
export function getLegalStatusApi() {
    return psHttp(requestConfigWrapper({
        url: `${coreBasicApiUrlPrefix}/analytics/config/legal-status`,
        method: 'GET',
        cache: true,
        transformCode: true
    }, persistCacheConf)).then(({ data }) => {
        return data.data || {};
    });
}
